/**
 * @file
 * Vue app for article improvement form.
 */

'use strict';

import Vue from 'vue';
import axios from 'axios';

Vue.component('article-improvement', {
  template: `
    <div class="modal-dialog cg-modal-dialog" :class="submitted ? 'pr-modal-dialog-narrow' : ''">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="modal-content">
        <div class="modal-body pr-form">
          <template v-if="submitted">
            <div class="pr-modal-icon">
              <img src="/themes/adaptive/images/icons/pr-thank-you.png" alt="" loading="lazy"/>
            </div>
            <div class="pr-modal-title pr-modal-title-thank">
              Спасибо!
            </div>
            <div class="pr-modal-text">
              Отзыв о статье отправлен, ваше мнение очень важно для нас!
            </div>
            <button type="button" class="btn--green" data-dismiss="modal" aria-label="Close">
                Хорошо
            </button>
          </template>
          <template v-else>
          <div class="modal-title pr-modal-title">
            {{ form.title }}
          </div>
          <div class="pr-modal-text">
            {{ form.text }}
          </div>
            <div class="pr-form" :class="{'pr-form--loading': loading}">
              <div class="pr-form-item">
                <label class="pr-form-label">
                  Введите ваш отзыв по статье *
                  <textarea type="text" maxlength="1000" rows="5" class="form-control pr-form-control" :class="{'pr-form-control--error': fields.message.error}" v-model="fields.message.value"></textarea>
                </label>
              </div>
              <div class="pr-form-row">
                <div class="pr-form-col pr-form-col--100">
                  <label class="pr-form-label">
                    Как с вами связаться? *
                    <input type="text" maxlength="250" class="form-control pr-form-control" :class="{'pr-form-control--error': fields.contact.error}" v-model="fields.contact.value">
                  </label>
                </div>
              </div>
              <div class="pr-messages pr-messages--red pr-messages--mb" v-if="message" v-html="message"></div>
              <div class="pr-form-item">
                <div class="pr-form-actions">
                  <div
                    class="pr-form-button btn--green"
                    :class="{'pr-form-button--loading': loading}"
                    :disabled="loading"
                    @click="validate">
                    Отправить отзыв
                  </div>
                </div>
              </div>
              <div class="pr-form-actions-text">
                Отправляя отзыв, вы автоматически соглашаетесь с <a href="/pravila-razmescheniya-materialov-na-sayte-wwwgarshinkaru" target="_blank" class="pr-form-actions-link">политикой конфиденциальности</a>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  `,
  data() {
    return {
      form: {
        title: 'Спасибо за оценку',
        text: 'Как мы можем улучшить статью?'
      },
      fields: {
        message: {
          value: '',
          error: false,
        },
        contact: {
          value: '',
          error: false,
        },
      },
      submitted: false,
      message: '',
      loading: false,
    }
  },
  methods: {
    submit() {
      axios.post('/forms/api/send-article-improvement', {
        message: this.fields.message.value,
        contact: this.fields.contact.value,
        url: window.location.href,
      }).then(() => {
        this.submitted = true;
      }).catch(() => {
        this.message = 'Произошла ошибка';
        this.loading = false;
      });
    },
    validate() {
      this.message = '';
      this.loading = true;

      for (const key in this.fields) {
        const field = this.fields[key];
        if (!field.value) {
          field.error = true;
          this.message = 'Заполните все поля в форме';

        }
        else {
          field.error = false;
        }
      }

      if (this.message) {
        this.loading = false;
        return false;
      }

      this.submit();
    },
  },
})

new Vue({
  el: '#article-improvement',
})
